import { connect } from 'react-redux'
import { getState, getDispatch } from 'x/modules/productlist/ProductListViewConnect'
import ProductListViewPullMyProductsToSalePage from './ProductListViewPullMyProductsToSalePage'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(ProductListViewPullMyProductsToSalePage)
